import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { RootState, store } from 'store/store';
import { LocalStore } from 'constants/localstore.ts';
import { handleRefreshToken } from './_api-reject-handler.ts';

export interface ApiRes {
  executionResult: boolean;
}

export const api = axios.create({
  baseURL: import.meta.env.VITE_DOMAIN_BASE,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(LocalStore.token);
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    config.url = addDefaultQueryParams(config);
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => await handleRefreshToken(error)
);

/* H E L P E R S */

const appendUrlParams = (url: string, params?: string): string => {
  if (!params) return url;
  const i = url.indexOf('?');
  return i === -1 ? url + params : url.substring(0, i) + params;
};

const addDefaultQueryParams = (config: AxiosRequestConfig) => {
  const url = new URL(config.baseURL + config.url!);
  const { selectedProject: projectId, selectedStory: storyId } = (store.getState() as RootState).projects;
  if (projectId && !url.searchParams.has('projectId')) url.searchParams.set('projectId', `${projectId}`);
  if (storyId && !url.searchParams.has('storyId')) url.searchParams.set('storyId', `${storyId}`);
  return appendUrlParams(config.url!, url.search);
};
